import { resolveEntries, describeElement } from './collect'
import { highlight, clearHighlight } from './highlight'

export const PICK_IMAGE_BYTES = 4 * 1024 * 1024
const IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp']
const inPanel = node => Boolean(node?.closest?.('#zeus-assistant-panel'))

/** 拾取模式：悬停画虚线框，点击选中后自动退出，Esc 退出。只有 ops 含 pick 的元素可选。 */
export function startPicker({ pageKey, root = document, onPick, onCancel }) {
  const targets = resolveEntries(pageKey, root).filter(item => item.entry.ops.includes('pick'))
  // 最内层优先：嵌套时（卡片里的字段）命中更具体的那个。
  const hit = node => targets.filter(t => t.el === node || t.el.contains(node))
    .sort((a, b) => (a.el.contains(b.el) ? 1 : b.el.contains(a.el) ? -1 : 0))[0]
  const docs = [...new Set([root, ...targets.map(t => t.frameEl?.contentDocument).filter(Boolean)])]
  let hovered
  const move = event => {
    const t = hit(event.target)
    if (t === hovered) return
    hovered = t
    if (t) highlight(t, { mode: 'pick' }); else clearHighlight()
  }
  const click = event => {
    if (inPanel(event.target)) return
    event.preventDefault()
    event.stopPropagation()
    const t = hit(event.target)
    if (!t) return
    stop()
    onPick(t)
  }
  // 原生 select、mousedown 监听在 click 之前就会响应：面板外的按下也一并吞掉。
  const down = event => {
    if (inPanel(event.target)) return
    event.preventDefault()
    event.stopPropagation()
  }
  const key = event => {
    if (event.key !== 'Escape') return
    event.preventDefault()
    stop()
    onCancel?.()
  }
  function stop() {
    for (const doc of docs) {
      doc.removeEventListener('pointermove', move, true)
      doc.removeEventListener('click', click, true)
      doc.removeEventListener('pointerdown', down, true)
      doc.removeEventListener('mousedown', down, true)
      doc.removeEventListener('keydown', key, true)
    }
    root.body?.classList.remove('zeus-ui-picking')
    clearHighlight()
  }
  for (const doc of docs) {
    doc.addEventListener('pointermove', move, true)
    doc.addEventListener('click', click, true)
    doc.addEventListener('pointerdown', down, true)
    doc.addEventListener('mousedown', down, true)
    doc.addEventListener('keydown', key, true)
  }
  root.body?.classList.add('zeus-ui-picking')
  return stop
}

/** 圈选时的引用：只有界面文字（与清单同结构的子集）。 */
export function refFor(target) {
  const { id, kind, label, section } = describeElement(target)
  return { id, kind, label, ...(section ? { section } : {}) }
}

export async function imageDataUrl(img, fetcher = (...args) => fetch(...args)) {
  const src = img?.currentSrc || img?.src
  if (!src) return null
  try {
    const blob = await (await fetcher(src)).blob()
    if (!IMAGE_TYPES.includes(blob.type) || blob.size > PICK_IMAGE_BYTES) return null
    return await new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(String(reader.result))
      reader.onerror = () => reject(reader.error)
      reader.readAsDataURL(blob)
    })
  } catch { return null }
}
